import PropTypes from 'prop-types'

import { Icon } from '../display/icon'

const PlanIcon = ({ label = 'Plan', ...rest }) => {
  return (
    <Icon
      label={label}
      {...rest}
      dangerouslySetGlyph={`<svg data-name="Layer 1" viewBox="0 0 300 300"><path d="M149.8 285.4a5 5 0 0 1-5-5v-40.5a5 5 0 0 1 10 0v40.5a5 5 0 0 1-5 5z" style="fill:#1d1d1b"/><path d="M149.8 244.9A92.2 92.2 0 0 1 120 65.5a5 5 0 0 1 3.2 9.5 82.2 82.2 0 1 0 26.6-4.4 5 5 0 0 1-5-5V25.2a5 5 0 1 1 10 0v35.5a92.2 92.2 0 0 1-5 184.2z" style="fill:#1d1d1b"/><path d="M274 157.8h-37.1a5.1 5.1 0 0 1-5-5 5 5 0 0 1 5-5H274a5 5 0 0 1 5 5 5 5 0 0 1-5 5zm-211.4 0h-37a5 5 0 0 1-5-5 5 5 0 0 1 5-5h37a5 5 0 0 1 5 5 5 5 0 0 1-5 5z" style="fill:#1d1d1b"/><circle cx="149.8" cy="152.8" r="38.1" style="fill:#fdc409"/><path d="M149.8 114.7a38.1 38.1 0 1 1-38.1 38.1 38.1 38.1 0 0 1 38.1-38.1m0-10a48.1 48.1 0 1 0 48.1 48.1 48.1 48.1 0 0 0-48.1-48.1z" style="fill:#1d1d1b"/></svg>`}
    />
  )
}

PlanIcon.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large'])
}

export { PlanIcon }
